import '@ta-interaktiv/semantic-ui/semantic/dist/components/progress.css'
import React from 'react'

interface IQuestProgress {
  index?: number
  length: number
}

export const QuestProgress = ({ index = 0, length }: IQuestProgress) => (
  <div className='ui top attached grey progress' id='progressbar'>
    <div
      className='bar'
      style={{ width: `${((index + 1) / length) * 100}%` }}
    />
  </div>
)
